var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{selected: _vm.isSelected},on:{"click":_vm.selectMonth}},[_vm._v(_vm._s(_vm.month.monthAndYear))])}
var staticRenderFns = []

export { render, staticRenderFns }